import { BodyText } from "@/components/ui";
import { Collapsible } from "@/components/ui/Collapsible";
import { formatPhoneNumber } from "@/lib/formatters";
import { MedicationRequest } from "@curai/js-fhir-tools";

export const MedicationDetails = ({
  medicationRequest,
}: { medicationRequest: MedicationRequest }) => {
  return (
    <Collapsible
      title={medicationRequest.medicationName}
      headerSize="sm"
      background="secondary"
      defaultOpen={true}
      status={
        medicationRequest.routingMethod ===
        MedicationRequest.ROUTING_METHOD.values.PHONE
          ? "Phoned In"
          : medicationRequest.dosespotStatusLabel
      }
    >
      <div className="grid grid-cols-2 gap-2">
        {medicationRequest.overrideReason && (
          <>
            <BodyText size="sm">InteractionOverride Reason</BodyText>
            <BodyText size="sm">{medicationRequest.overrideReason}</BodyText>
          </>
        )}
        <BodyText size="sm" bold>
          Patient Instructions
        </BodyText>
        <BodyText size="sm">{medicationRequest.sig}</BodyText>
        <BodyText size="sm" bold>
          Dispense Amount
        </BodyText>
        <BodyText size="sm">
          {medicationRequest.dispenseQuantity}{" "}
          {medicationRequest.dispenseUnitDisplay}
        </BodyText>
        <BodyText size="sm" bold>
          Days Supply
        </BodyText>
        <BodyText size="sm">{medicationRequest.daysSupply}</BodyText>
        <BodyText size="sm" bold>
          Refills
        </BodyText>
        <BodyText size="sm">{medicationRequest.refills}</BodyText>
        {medicationRequest.noteToPharmacy && (
          <>
            <BodyText size="sm" bold>
              Notes For Pharmacy
            </BodyText>
            <BodyText size="sm">{medicationRequest.noteToPharmacy}</BodyText>
          </>
        )}
        <BodyText size="sm" bold>
          Substitutions Allowed
        </BodyText>
        <BodyText size="sm">
          {medicationRequest.substitutionAllowed ? "Allowed" : "Not Allowed"}
        </BodyText>
        <BodyText size="sm" bold>
          Routing Method
        </BodyText>
        <BodyText size="sm">{medicationRequest.routingMethodLabel}</BodyText>
        <BodyText size="sm" bold>
          Pharmacy
        </BodyText>
        <div className="flex flex-col">
          <BodyText size="sm">{medicationRequest.pharmacyName}</BodyText>
          {medicationRequest.pharmacyAddress?.line?.map((line) => (
            <BodyText size="sm" key={line}>
              {line}
            </BodyText>
          ))}
          {Boolean(medicationRequest.pharmacyAddress) && (
            <BodyText size="sm">
              {medicationRequest.pharmacyAddress?.city},{" "}
              {medicationRequest.pharmacyAddress?.state}{" "}
              {medicationRequest.pharmacyAddress?.postalCode}
            </BodyText>
          )}
          <BodyText size="sm">
            {formatPhoneNumber(medicationRequest.pharmacyPhone)}
          </BodyText>
        </div>
        {medicationRequest.routingMethod ===
          MedicationRequest.ROUTING_METHOD.values.EPRESCRIBE && (
          <>
            <BodyText size="sm" bold>
              eRx Status
            </BodyText>
            <BodyText size="sm">
              {medicationRequest.dosespotStatusLabel}
            </BodyText>
          </>
        )}
        {medicationRequest.routingMethod ===
          MedicationRequest.ROUTING_METHOD.values.EPRESCRIBE && (
          <>
            <BodyText size="sm" bold>
              eRx Order ID
            </BodyText>
            <BodyText size="sm">{medicationRequest.dosespotOrderId}</BodyText>
          </>
        )}
        <BodyText size="sm" bold>
          Prescribed By
        </BodyText>
        <BodyText size="sm">
          {medicationRequest.orderingPhysician.display}
        </BodyText>
        {medicationRequest.supervisingPhysician && (
          <>
            <BodyText size="sm" bold>
              Supervising Physician
            </BodyText>
            <BodyText size="sm">
              {medicationRequest.supervisingPhysician.display}
            </BodyText>
          </>
        )}
      </div>
    </Collapsible>
  );
};
